import React from "react";
import { connect } from "react-redux";

import {
  Transition,
  Container,
  Header,
  Segment,
  Button
} from "semantic-ui-react";
import TablaAlumnos from "./listadoAlumnos/TablaAlumnos";
import { alumnosOps } from "../../ducks/alumnos";
import _ from "lodash";

class ListadoAlumnos extends React.Component {
  componentDidMount() {
    this.props.obtenerListaAlumnos();
  }

  componentWillUnmount() {
    this.props.resetListaAlumnos();
  }

  handleRowClick = id => this.props.history.push(`/detalle/alumno/${id}`);

  handleBorrarAlumno = idAlumno => this.props.eliminarAlumno(idAlumno);

  handleVolver = () => this.props.history.goBack();

  render() {
    return (
      <Transition.Group animation="scale" duration={250}>
        {!_.isEmpty(this.props.listaAlumnos) && (
          <Container textAlign="center">
            <Segment basic>
              <Button
                content="Cerrar"
                floated="right"
                color="pink"
                icon="cancel"
                onClick={this.handleVolver}
              />

              <Header inverted as="h2">
                Listado de Alumnos
              </Header>
            </Segment>
            <Segment loading={_.isEmpty(this.props.listaAlumnos)}>
              <TablaAlumnos
                listaAlumnos={this.props.listaAlumnos}
                handleRowClick={this.handleRowClick}
                handleBorrarAlumno={this.handleBorrarAlumno}
                editable={true}
              />
            </Segment>
          </Container>
        )}
      </Transition.Group>
    );
  }
}

const mapStateToProps = state => ({
  listaAlumnos: state.alumnos.listaAlumnos
});

const actions = {
  obtenerListaAlumnos: alumnosOps.obtenerListaAlumnos,
  resetListaAlumnos: alumnosOps.resetListaAlumnos,
  eliminarAlumno: alumnosOps.eliminarAlumno
};

export default connect(mapStateToProps, actions)(ListadoAlumnos);



// WEBPACK FOOTER //
// ./src/pages/listados/ListadoAlumnos.jsx